import ProfessionalReviewItem from './ProfessionalReviewItem';

class ProfessionalReview {
    /**
     * Create a new instance of professionalreview
     * @param {object} professionalReviewData A professionalReview object from novelist select
     */

     constructor(professionalReviewData) {         
         this.publication = professionalReviewData.Publication;
         this.publicationCode = professionalReviewData.PublicationCode;
         this.reviews = [ new ProfessionalReviewItem(professionalReviewData)];                  
     }     
}

export default ProfessionalReview;


// WEBPACK FOOTER //
// ./src/models/ProfessionalReview.js